import { io } from "socket.io-client";

const URL = process.env.REACT_APP_CHAT_WS || window.location.host;

export const socket = io(URL, {
    transports: ["websocket"]
});
